import Head from 'next/head'
import { type ReactElement, useEffect } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../../shared/components/ui/headings/PageHeading'
import { proxyGlobalAuth } from '../../../../shared/proxies/proxyGlobalAuth'
import { executeCustomersSearch } from '../../../../shared/apiUtils/executeCustomersSearch'
import ErrorBoundary from '../../../../shared/components/errorBoundary/ErrorBoundary'
import { CustomerAddSlideOver } from '../../../../shared/components/CustomerAddSlideOver/CustomerAddSlideOver'
import { handleSubmitForCustomerListCreate } from '../../../../shared/components/CustomerAddSlideOver/utils'
import { CustomerSearchBox } from './components/CustomerSearchBox'
import { CustomerTable } from './components/CustomerTable'
import AddCustomerButton from './components/AddCustomerButton'

export function CustomersMainContainer (): ReactElement {
  useEffect(() => {
    void executeCustomersSearch({ displayLoader: true })
  }, [])
  const { siteTheme: { tableMainColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <>
      <Head>
        <title>Customers</title>
      </Head>
      <CustomerAddSlideOver submitFunction={handleSubmitForCustomerListCreate} />

      <Breadcrumbs breadcrumbs={[{ text: 'Customers' }]} />
      <PageHeading text="Quickly and easily manage your customers." />
      <div className="flex justify-between my-4">
        <CustomerSearchBox />
        <AddCustomerButton />
      </div>
      <div className={cn(tableMainColors.classes, 'bg-white border-t-4 shadow rounded  mb-32')}>
        <ErrorBoundary>
          <CustomerTable />
        </ErrorBoundary>
      </div>
    </>
  )
}
